import { ChakraProvider, CSSReset, Box } from '@chakra-ui/react';
import theme from '@/theme/index';
import Navbar from './components/Navbar';
import Banner from './components/Banner';
import Services from './components/Services';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <CSSReset />
      <Box position="relative">
        <Navbar />
        <Box as="main">
          <Banner />
          <Services />
          <Experience />
          <Skills />
          <Projects />
          <Contact />
        </Box>
        <Footer />
      </Box>
    </ChakraProvider>
  );
}

export default App;
